import React from 'react'

const AccountStatementPlaceholder = props => (
  <div className='item-content col-12 txt-font-body txt-body-sm color-ui-2 radius-bottom'>
    <div className='extract-item pos-relative row'>
      <div className='col-auto pl-0 my-2 zindex-low'>
        <i className={`icon icon_loading txt-body-lg`} />
      </div>
      <div className='col mt-3'>
        <p className='txt-subtitle row mx-0'>
          <div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' />
        </p>
        <p className='mt-half txt-body-sm'>
          <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
        </p>

      </div>
      <div className='d-none d-md-block col-auto mt-3'>
        <div className='px-2 mr-1 py-half radius bg-ui-3 mb-0' />
      </div>
    </div>
    <div className='extract-item pos-relative row'>
      <div className='col-auto pl-0 my-2 zindex-low'>
        <i className={`icon icon_loading txt-body-lg`} />
      </div>
      <div className='col my-2'>
        <p className='txt-subtitle row mx-0'>
          <div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' />
        </p>
        <p className='mt-half txt-body-sm'>
          <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
        </p>

      </div>
      <div className='d-none d-md-block col-auto mt-3'>
        <div className='px-2 mr-1 py-half radius bg-ui-3 mb-0' />
      </div>
    </div>
    <div className='extract-item pos-relative row'>
      <div className='col-auto pl-0 my-2 zindex-low'>
        <i className={`icon icon_loading txt-body-lg`} />
      </div>
      <div className='col my-2'>
        <p className='txt-subtitle row mx-0'>
          <div className='col-4 mr-1 py-half radius bg-ui-3 mb-1' />
        </p>
        <p className='mt-half txt-body-sm'>
          <div className='col-5 mr-1 py-half radius bg-ui-3 mb-0' />
        </p>

      </div>
      <div className='d-none d-md-block col-auto mt-3'>
        <div className='px-2 mr-1 py-half radius bg-ui-3 mb-0' />
      </div>
    </div>
  </div>
)

export default AccountStatementPlaceholder



// WEBPACK FOOTER //
// ./src/Participant/Extract/Details/AccountStatementPlaceholder.js